import { CalloutBlockComponent } from './callout-block';
import { EmojiMenu } from './emoji-menu';

export function effects() {
  customElements.define('hive-callout', CalloutBlockComponent);
  customElements.define('hive-emoji-menu', EmojiMenu);
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-callout': CalloutBlockComponent;
    'hive-emoji-menu': EmojiMenu;
  }
}
